'use client';
import { useEffect, useRef } from 'react';
import { useModal } from '../../../features/providers/modal-provider';
const Modal = (props) => {
    var _a;
    const { upsertModal, deleteModal } = useModal();
    const modalId = useRef((_a = props.id) !== null && _a !== void 0 ? _a : (typeof crypto !== 'undefined' && crypto.randomUUID
        ? crypto.randomUUID()
        : Math.random().toString(36).slice(2)));
    useEffect(() => {
        upsertModal(Object.assign(Object.assign({}, props), { id: modalId.current }));
    }, [props, upsertModal]);
    useEffect(() => {
        const id = modalId.current;
        return () => {
            deleteModal(id);
        };
    }, [deleteModal]);
    return null;
};
export default Modal;
